<script>
import { Helper } from '@/mixin/helper'
import McGraphqlEditableTable from '@/components/McGraphqlEditableTable'
import {
  GET_CATEGORY,
  CATEGORY_MUTATION_CREATE,
  CATEGORY_MUTATION_DELETE,
  CATEGORY_MUTATION_UPDATE,
  GET_CATEGORY_BY_ID,
} from '@/services/api/setting/fleet/fleetCat'

export default {
  components: {
    McGraphqlEditableTable,
  },
  mixins: [Helper],
  props: {
    status: String,
  },
  data() {
    return {
      data: [],
    }
  },
  computed: {
    iconOptions() {
      return [
        {
          label: this.$t('setting.list.fleetSetting.icon.bigTruck'),
          value: 'bigTruck',
          img: require('@/assets/images/vehicles/bigTruck/bigTruck-blue.png'),
          style: 'transform: rotate(270deg); width: 14px',
        },
        {
          label: this.$t('setting.list.fleetSetting.icon.bus'),
          value: 'bus',
          img: require('@/assets/images/vehicles/bus/bus-blue.png'),
          style: 'transform: rotate(270deg); width: 14px',
        },
        {
          label: this.$t('setting.list.fleetSetting.icon.car'),
          value: 'car',
          img: require('@/assets/images/vehicles/car/car-blue.png'),
          style: 'transform: rotate(270deg); width: 14px',
        },
        {
          label: this.$t('setting.list.fleetSetting.icon.container'),
          value: 'container',
          img: require('@/assets/images/vehicles/container/container-blue.png'),
          style: 'transform: rotate(270deg); width: 14px',
        },
        {
          label: this.$t('setting.list.fleetSetting.icon.doubleCabin'),
          value: 'doubleCabin',
          img: require('@/assets/images/vehicles/doubleCabin/doubleCabin-blue.png'),
          style: 'transform: rotate(270deg); width: 14px',
        },
        {
          label: this.$t('setting.list.fleetSetting.icon.electricCar'),
          value: 'electricCar',
          img: require('@/assets/images/vehicles/electricCar/electricCar-blue.png'),
          style: 'transform: rotate(270deg); width: 14px',
        },
        {
          label: this.$t('setting.list.fleetSetting.icon.electricMotor'),
          value: 'electricMotorcycle',
          img: require('@/assets/images/vehicles/electricMotorcycle/electricMotorcycle-blue.png'),
          style: 'transform: rotate(270deg); width: 14px',
        },
        {
          label: this.$t('setting.list.fleetSetting.icon.excavator'),
          value: 'excavator',
          img: require('@/assets/images/vehicles/excavator/excavator-blue.png'),
          style: 'transform: rotate(270deg); width: 14px',
        },
        {
          label: this.$t('setting.list.fleetSetting.icon.motorcycle'),
          value: 'motorcycle',
          img: require('@/assets/images/vehicles/motorcycle/motorcycle-blue.png'),
          style: 'transform: rotate(270deg); width: 14px',
        },
        {
          label: this.$t('setting.list.fleetSetting.icon.smallTruck'),
          value: 'smallTruck',
          img: require('@/assets/images/vehicles/smallTruck/smallTruck-blue.png'),
          style: 'transform: rotate(270deg); width: 14px',
        },
        {
          label: this.$t('setting.list.fleetSetting.icon.tractor'),
          value: 'tractor',
          img: require('@/assets/images/vehicles/tractor/tractor-blue.png'),
          style: 'transform: rotate(270deg); width: 14px',
        },
        {
          label: this.$t('setting.list.fleetSetting.icon.truckHead'),
          value: 'truckHead',
          img: require('@/assets/images/vehicles/truckHead/truckHead-blue.png'),
          style: 'transform: rotate(270deg); width: 14px',
        },
        {
          label: this.$t('setting.list.fleetSetting.icon.van'),
          value: 'van',
          img: require('@/assets/images/vehicles/van/van-blue.png'),
          style: 'transform: rotate(270deg); width: 14px',
        },
      ]
    },
    fields() {
      return [
        {
          key: 'category',
          label: this.$t('setting.list.fleetSetting.fleetCategory'),
          placeholder: 'Pilih Kategori Kendaraan',
          isEditable: true,
          isSortable: false,
          validation: [['required']],
          thClass: 'mc-table--500',
        },
        {
          key: 'icon',
          label: this.$t('setting.list.fleetSetting.illustration'),
          placeholder: 'Pilih ' + this.$t('setting.list.fleetSetting.illustration'),
          isEditable: true,
          isSortable: false,
          hasImage: true,
          type: 'select-resourceful',
          trackBy: 'value',
          optionsGetter: this.resourcefulQuery.icons,
          optionLabelFn: ({ item }) => {
            return {
              label: item?.icon?.label,
              value: item?.icon?.value,
              img: item?.icon?.img,
              style: item?.icon?.style,
            }
          },
          getInitialObject: (item) => {
            return {
              label: item?.icon?.label,
              value: item?.icon?.value,
              img: item?.icon?.img,
              style: item?.icon?.style,
            }
          },
          customValueFn: (item) => item?.icon?.value ?? '',
          customColumn: true,
          validation: [['required']],
          thClass: 'mc-table--500',
          thStyle: 'width: 500px',
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          let result = []
          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: GET_CATEGORY,
            variables: {
              filter: filter,
            },
          })

          let self = this

          result = res.data.vehicleCategories.vehicleCategories
          result.data.forEach((item, index) => {
            if (item.companyId == 1) {
              result.data[index].disableCheckbox = true
              result.data[index].isShowEdit = false
            }
            const iconType = this.iconOptions.find((icon) => icon.value == item.icon)
            if (iconType !== undefined) result.data[index].icon = iconType
          })
          self.data = result.data

          return result
        },
        store: async (input) => {
          const res = await this.$apollo.mutate({
            fetchPolicy: 'no-cache',
            mutation: CATEGORY_MUTATION_CREATE,
            variables: {
              input: input,
            },
          })

          if (!res.data.createVehicleCategory.isSuccessful) {
            this.$mcToast.error(this.$t('global.failed'))
            return
          }

          const dataById = await this.$apollo.query({
            query: GET_CATEGORY_BY_ID,
            fetchPolicy: 'no-cache',
            variables: {
              filter: { category: input.category },
            },
          })
          let newData = dataById.data.vehicleCategory.vehicleCategory

          const iconType = this.iconOptions.find((icon) => icon.value == newData.icon)
          if (iconType !== undefined) newData.icon = iconType

          const self = this
          self.data.push(newData)
          return newData
        },
        update: async (category, oldData, newData) => {
          const input = {
            category: oldData.category,
            data: {
              category: newData.category,
              icon: newData.icon,
            },
          }

          const res = await this.$apollo.mutate({
            fetchPolicy: 'no-cache',
            mutation: CATEGORY_MUTATION_UPDATE,
            variables: {
              input: input,
            },
          })

          if (!res.data.updateVehicleCategory.isSuccessful) {
            this.$mcToast.error(this.$t('global.failed'))
            return
          }
          return res.data.updateVehicleCategory.isSuccessful
        },
        delete: async (category) => {
          const input = {
            category: category,
          }
          const res = await this.$apollo.mutate({
            fetchPolicy: 'no-cache',
            mutation: CATEGORY_MUTATION_DELETE,
            variables: {
              input: input,
            },
          })

          return res.data.deleteVehicleCategory
        },
      }
    },
    resourcefulQuery() {
      return {
        icons: async (opts) => {
          let result = {}
          if (opts.page !== 1) {
            result = {
              metadata: {
                total_page: 1,
                total_count: 0,
                page: 1,
              },
              data: {
                paginated_result: [],
              },
            }
          } else {
            let iconOptions = this.iconOptions

            if (opts.search) {
              iconOptions = iconOptions.filter((item) => this.isContains(opts.search, item.label))
            }
            result = {
              metadata: {
                total_page: 1,
                total_count: iconOptions.length,
                page: 1,
              },
              data: {
                paginated_result: iconOptions,
              },
            }
          }
          return result
        },
      }
    },
  },
  methods: {
    async handleChange() {
      const fleetCatRef = this.$refs.fleetCatRef.$refs
      await this.$nextTick()
      fleetCatRef['icon-ref'].$el.addEventListener('keydown', this.preventTabKey)
      fleetCatRef['category-ref'].$el.addEventListener('keydown', this.preventTabKey)
    },
    preventTabKey(event) {
      if (event.keyCode === 9) {
        // Tab key
        event.preventDefault()
      }
    },
  },
}
</script>

<template>
  <!-- Fleet Type -->
  <b-tab class="border-0" @click="$store.commit('setting/SET_STATUS', status)">
    <template #title>
      <span class="d-sm-inline-block">{{ $t('setting.list.fleetSetting.fleetCategory') }}</span>
    </template>

    <!-- Table -->
    <div class="table-responsive my-3">
      <McGraphqlEditableTable
        ref="fleetCatRef"
        :fields="fields"
        :apiClient="query"
        :isPredefined="true"
        :searchable="true"
        :idIsString="true"
        trackBy="category"
        @changeData="handleChange"
      >
        <template #icon="data">
          <img
            :src="data.value.img"
            class="px-3"
            height="52px"
            style="transform: rotate(270deg)"
            :alt="data.value.value"
          />
        </template>
      </McGraphqlEditableTable>
    </div>
  </b-tab>
</template>
